import React from 'react'
import TitleBinder from './TitleBinder'
import MeterBinder from './MeterBinder'
import ButtonBinder from './ButtonBinder'

function Top(props) {

    return (<div>
      <header className="navbar pt-2">
        <TitleBinder></TitleBinder>
        <MeterBinder></MeterBinder>
        <ButtonBinder></ButtonBinder>
      </header>
    </div>)
  
}
export default Top



// WEBPACK FOOTER //
// ./src/topModule/Top.js